import {
	Submitter,
	InputChangeHandler,
} from '../component'
import Modal from './modal'
import Collapsible from './collapsible'

const Global = (() => {
	const init = () => {
		const modal = Modal()
		const collapsible = Collapsible()

		Submitter.init()
		InputChangeHandler.init()
		modal.init()
		collapsible.init()
	}

	return {
		init,
	}
})()

export default Global
